import React from 'react';

interface PillActionButtonProps {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    label: string;
    title?: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
}

const PillActionButton: React.FC<PillActionButtonProps> = ({ icon: Icon, label, title, onClick, disabled, loading }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled || loading}
            title={title ?? label}
            className="flex items-center gap-[4px] h-[28px] pl-[2px] pr-[10px] rounded-full overflow-hidden transition-colors
                text-[#2255a1] bg-transparent
                hover:bg-[#153c76] hover:text-white
                dark:text-[#d3ddec] dark:hover:bg-[#eef2ff] dark:hover:text-[#1e293b]
                disabled:opacity-50"
        >
            {loading ? (
                <svg className="animate-spin w-[20px] h-[20px] shrink-0" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"/>
                </svg>
            ) : (
                <Icon width={24} height={24} style={{ fill: 'currentColor' }} className="shrink-0" />
            )}
            <span className="hidden md:inline text-[12px] select-none whitespace-nowrap">
                {label}
            </span>
        </button>
    );
};

export default PillActionButton;
